import $api from "@/frontend/shared/api/axios";

export function cancelRequest(id: number) {
  return $api.post("access-controls/cancel-request", {
    companyId: id
  });
}
